import ChannelGuideRail from '../railTypes/channelGuideRail';
import Container from '../../../../atoms/container/railSelectorContainer';
import Direction from '../../../../../../shared/types/enums/direction';
import EpgRail from '../railTypes/epgRail';
import FilterRail from '../railTypes/filterRail';
import KeepWatchingRail from '../railTypes/keepWatchingRail';
import RailProps from '../../../../../../shared/types/props/rail';
import MosaicRail from '../railTypes/mosaicRail';
import RecommendationsRail from '../railTypes/recommendationsRail';
import RecordingsRail from '../railTypes/recordsRail';
import RegularRail from '../railTypes/regularRail';
import { RailType } from '../../../../../../shared/types/enums/rail';
import { useMemo } from 'react';

interface Props extends RailProps {
  type: RailType;
}

function RailSelector(props: Props) {
  const { animation, list, style, type } = props;
  const [Component, containerStyle] = useMemo(() => {
    const containerStyle =
      type === RailType.FILTER || type === RailType.GUIDE_CHANNEL
        ? {}
        : { animation, style };
    let Component = null;
    switch (type) {
      case RailType.CHANNEL:
      case RailType.EPG:
        Component = EpgRail;
        break;
      case RailType.FILTER:
        Component = FilterRail;
        break;
      case RailType.GUIDE_CHANNEL:
        Component = ChannelGuideRail;
        break;
      case RailType.KEEP_WATCHING:
        Component = KeepWatchingRail;
        break;
      case RailType.MOSAIC:
        Component = MosaicRail;
        break;
      case RailType.RECOMMENDATIONS:
        Component = RecommendationsRail;
        break;
      case RailType.RECORDING:
        Component = RecordingsRail;
        break;
      case RailType.REGULAR:
        Component = RegularRail;
        break;
    }
    return [Component, containerStyle];
  }, [animation, style, type]);
  return (
    <Container {...containerStyle}>
      <Component
        list={{
          ...props,
          ...list,
          direction: Direction.HORIZONTAL,
          initialIndex: props.list.index ?? undefined,
          numberOfPressures: 3,
        }}
        style={style}
        animation={animation}
      />
    </Container>
  );
}

export default RailSelector;
